export default function initAffiliateCopy() {
  const buttons = document.querySelectorAll('[data-copy-target]');
  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(button.dataset.copyTarget);
      if (!target) return;

      const value = target.value || target.textContent || '';
      const original = button.textContent;

      const done = () => {
        button.textContent = 'Copied';
        button.disabled = true;
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(done).catch(() => {
          target.select();
          document.execCommand('copy');
          done();
        });
      } else {
        target.select();
        document.execCommand('copy');
        done();
      }
    });
  });
}
